export const baseComponents = {
  SocioCategory: () => import("./SocioCategory.vue"),
  SocioQuestionnaireNode: () => import("./SocioQuestionnaireNode.vue"),
  SocioQuestionnaireCheckbox: () => import("./SocioQuestionnaireCheckbox.vue"),
  SocioQuestionnaireOrderBtn: () => import("./SocioQuestionnaireOrderBtn.vue"),
  SocioQuestionnaireQualityIndex: () =>
    import("./SocioQuestionnaireQualityIndex.vue"),
};
